<sn-modal-popup [isShowModal]="true">
  <ng-container class="sn-modal-header">
    <h2 class="slds-text-heading_medium slds-hyphenate">Data Binding</h2>
  </ng-container>
  <ng-container class="sn-modal-content">
    <app-data-binding-base-form
      (updateLoadingE)="updateLoading($event)"
      [document]="document"
      [recordType]="recordType"
      [isNeedShowForm]="isNeedShowForm"
      [isUserOwnerOfDocument]="isUserOwnerOfDocument"
      [sfObjectsSuggestionList]="sfObjectsSuggestionList"
    >
    </app-data-binding-base-form>
  </ng-container>
  <ng-container class="sn-modal-footer">
    <span *ngIf="isNeedShowForm == true && !isUserOwnerOfDocument"
      >You don`t have enough permission to edit this template. &nbsp;&nbsp;</span
    >
    <button
      *ngIf="isNeedShowForm == true"
      class="btn btn-primary"
      (click)="addPushbackDataToDocument()"
      [disabled]="!isUserOwnerOfDocument"
    >
      Submit
    </button>
    <button
      class="btn btn-neutral"
      (click)="
        isNeedShowForm && isUserOwnerOfDocument ? resetDataAndUpdateError(false, true) : hideAllModals()
      "
    >
      Cancel
    </button>
  </ng-container>
</sn-modal-popup>
